export const mockRouteCode = [
  'KV_MIENTAY',
  'KV_HCM3',
  'KV_TAYNGUYEN',
  'KV_HCM1',
  'KV_HCM10',
  'KV_MIENBAC',
  'KV_DNB',
  'KV_HCM2',
  'KV_MIENTRUNG',
];

export const mockRouteName = [
  'KV_HCM1',
  'KV_MIENTAY',
  'KV_HCM10',
  'KV_HCM3',
  'KV_MIENBAC',
  'KV_DNB',
  'KV_HCM2',
  'KV_TAYNGUYEN',
  'KV_MIENTRUNG',
];

export const mockOrgCode = [
  'CN102014',
  'CN106004',
  'CN101055',
  'CN101006',
  'CN101056',
  'CN103046',
  'CN101047',
  'CN101039',
  'CN101033',
  'CN101029',
  'CN103023',
  'CN101034',
  'CN101022',
  'CN106011',
  'CN105001',
  'CN106049',
  'CN102008',
  'CN104050',
  'CN104015',
  'CN101031',
  'CN103048',
  'CN102038',
  'CN102040',
  'CN103003',
  'CN106042',
  'CN106004',
  'CN106017',
  'CN104035',
  'CN103005',
  'CN101002',
  'CN105045',
  'CN104025',
  'CN103013',
  'CN104051',
  'CN102037',
  'CN106009',
  'CN104028',
  'CN104019',
  'CN104027',
  'CN103018',
  'CN101054',
  'CN102036',
  'CN101020',
  'CN104016',
  'CN106010',
  'CN103026',
  'CN105030',
  'CN101057',
  'CN101043',
  'CN102024',
  'CN105007',
  'CN101053',
  'CN103012',
  'CN101021',
  'CN101044',
  'CN101032',
  'CN101052',
  'CN103041',
];

export const mockDepartmentName = [
  'TTKH An Đông',
  'TTKH Hoàng Văn Thụ GLI',
  'TTKH 139 Trần Hưng Đạo Sóc Trăng',
  'TTKH Đồng Khởi BTE',
  'Co.op Nguyễn Kiệm',
  'CH Bạc Thị Nghè',
  'Co.op Gò Công',
  'TTKH 266A Trần Nguyên Hãn, Hải Phòng',
  'TP. Phủ Lý',
  'Vincom Phạm Ngọc Thạch',
  'Sân bay Đà Nẵng - Quốc tế',
  'TTKH Hai Bà Trưng LXN',
  'TTKH_DC_Nguyễn Văn Trỗi PNN',
];

export const mockRoleUser = [
  {
    id: 1,
    value: 'cua_hang_truong',
    title: 'Cửa hàng trưởng',
  },
  {
    id: 2,
    value: 'nguoi_dat_hang',
    title: 'Người đặt hàng',
  },
  {
    id: 3,
    value: 'admin',
    title: 'Admin',
  },
  {
    id: 4,
    value: 'quan_ly',
    title: 'CUKV',
  },
  {
    id: 5,
    value: 'asm',
    title: 'ASM',
  },
  {
    id: 6,
    value: 'rsm',
    title: 'RSM',
  },
  {
    id: 7,
    value: 'giam_doc_chi_nhanh',
    title: 'Giám đốc chi nhánh',
  },
  {
    id: 8,
    value: 'quan_ly_danh_muc',
    title: 'Quản lý danh mục',
  },
];
export const mockRoleGroupUser = [
  // {
  //   id: 1,
  //   value: 'rsm',
  //   title: 'RSM',
  // },
  // {
  //   id: 2,
  //   value: 'asm',
  //   title: 'ASM',
  // },
  {
    id: 1,
    value: 'admin_full',
    title: 'Admin',
  },
];

export const convertRole = (role: string) => {
  switch (role) {
    case 'cua_hang_truong':
      return 'Cửa hàng trưởng';
    case 'nguoi_dat_hang':
      return 'Người đặt hàng';
    case 'admin':
      return 'Admin';
    case 'quan_ly':
      return 'Quản lý';
  }
};
